import React, { FC } from 'react'
import { useHistory } from 'react-router-dom'
import { Tabs } from '@ally/metronome-ui'
import { BeneficiaryTab } from '../../types'

export const BeneficiariesTabs: FC<{
  tabs: BeneficiaryTab[]
  activeTab: number
  headerRef: any
}> = ({ tabs, activeTab, headerRef }) => {
  const history = useHistory()

  const handleNavClick = (selected: number): void => {
    if (selected === 0) {
      history.push(`/beneficiaries/${tabs[0].tabName}`)
    } else if (selected === 1) {
      history.push(`/beneficiaries/${tabs[1].tabName}`)
    } else {
      history.push(`/beneficiaries/${tabs[2].tabName}`)
    }
    // On route change, the focus gets taken to the Ally logo at the top of the page.
    // To prevent this from happening, we need to programmatically bring the focus back to the content headers.
    requestAnimationFrame(() => headerRef.current?.focus())
  }

  return (
    <Tabs
      tabs={tabs.map((tab: BeneficiaryTab) => tab.tabDetails)}
      initialSelectedTab={activeTab}
      accessibleDropdownTitle="Beneficiaries Account Types Tabs"
      onSelectedTabChange={(index: number): void => handleNavClick(index)}
      disableContainer
      key={activeTab}
    />
  )
}
